<!--
 * @Description: 活动墙模块
 * @Author: F-Stone
 * @LastEditTime: 2023-10-31 18:18:08
-->

<template>
    <div :class="$style['m-story']">
        <div>
            <div :class="$style['m-bg']">
                <!-- <div :class="[$style['m-bg'], { mirrorRotateLevel: isDirection }]"> -->
                <video ref="video" preload="auto" autoplay muted playsinline src="@/assets/images/video/story-bg.mp4" />
            </div>
        </div>
        <div class="m-container" :class="$style['m-container']">
            <div :class="$style['container-inner']">
                <div :class="$style['module-head']" class="flex justify-center">
                    <div :class="$style['module-info']">
                        <h2 :class="$style['module-title']" class="enter-animate animate__fadeInUp">
                            <span class="text">
                                <!-- The Story of <br />
                our activity wall in pictures <br />with superex -->
                                <!-- SuperEX Exciting Recap -->
                                {{$t('400003')}}
                            </span>
                        </h2>
                        <h3 :class="$style['module-subtitle']" class="enter-animate animate__fadeInUp">
                            <span class="text">
                                <!-- Active Engagement and Shared Smiles: The Story of Our Activity
                Wall -->
                                <!-- new -->
                                <!-- Active Engagement and Shared Smiles: The Story of Our Activity Wall -->
                                {{$t('400004')}}
                            </span>
                        </h3>
                    </div>
                </div>
                <div :class="$style['module-body']">
                    <div ref="swiperDom" class="swiper enter-animate animate__fadeInUp" :class="$style['swiper']">
                        <div class="swiper-wrapper">
                            <template v-for="(item, index) in storyList">
                                <div :key="index + '-group1'" class="swiper-slide grid-flow-col-dense" :class="$style['list-item']">
                                    <div :class="$style['item-group1']" class="inline-grid">
                                        <div v-for="(img, i) in item.group1" :key="i" :class="$style['image-box']">
                                            <img :src="img" />
                                        </div>
                                    </div>
                                </div>
                                <div :key="index + '-group2'" class="swiper-slide grid-flow-col-dense" :class="$style['list-item']">
                                    <div :class="$style['item-group2']" class="inline-grid">
                                        <div v-for="(img, i) in item.group2" :key="i" :class="$style['image-box']">
                                            <img :src="img" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div :class="$style['swiper-nav']" class="flex justify-center">
                        <div class="items-center grid grid-cols-2 gap-3">
                            <button ref="prevBtn" :class="$style['btn--swiper-prev']" class="flex justify-center items-center">
                                <UeIcon :class="{mirrorRotateLevel:isDirection}" name="long-arrow-left" />
                            </button>
                            <button ref="nextBtn" :class="$style['btn--swiper-next']" class="flex justify-center items-center">
                                <UeIcon :class="{mirrorRotateLevel:isDirection}" name="long-arrow-right" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import Swiper from "@stone/uemo-utils/utils/swiper";
import Swiper from '../../../utils/swiper'
// import { storyList } from "@superex/public/data/story";
// import { storyList } from "../../../data/story";
import * as configs from '@/../config/config'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            swipe: null,
            observer: null,
            staticState: configs[configs.Edition].staticState,
            storyList: [],
        }
    },
    created() {
            window.document.documentElement.setAttribute(
            "dir",
            this.isDirection ? "rtl" : "ltr"
    );
    },
    computed: {
        ...mapGetters(['isDirection', 'language']),
    },
    methods: {
        initializeStoryList() {
            this.storyList.push(
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap1.png',
                        this.staticState + 'static/images/NewHome/Recap2.png',
                        this.staticState + 'static/images/NewHome/10.05en.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap3.png',
                        this.staticState + 'static/images/NewHome/20en.png',
                        this.staticState + 'static/images/NewHome/Recap4.png',
                        this.staticState + 'static/images/NewHome/Recap5.png',
                    ],
                },
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap6.png',
                        this.staticState + 'static/images/NewHome/400en.png',
                        this.staticState + 'static/images/NewHome/426en.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap7.png',
                        this.staticState + 'static/images/NewHome/6.5en.png',
                        this.staticState + 'static/images/NewHome/Recap8.png',
                        this.staticState + 'static/images/NewHome/Recap9.png',
                    ],
                },
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap10.png',
                        this.staticState + 'static/images/NewHome/Recap11.png',
                        this.staticState + 'static/images/NewHome/Recap12.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap13.png',
                        this.staticState + 'static/images/NewHome/Recap14.png',
                        this.staticState + 'static/images/NewHome/Recap15.png',
                        this.staticState + 'static/images/NewHome/Recap16.png',
                    ],
                },
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap17.png',
                        this.staticState + 'static/images/NewHome/Recap18.png',
                        this.staticState + 'static/images/NewHome/Recap19.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap20.png',
                        this.staticState + 'static/images/NewHome/Recap21.png',
                        this.staticState + 'static/images/NewHome/Recap22.png',
                        this.staticState + 'static/images/NewHome/Recap23.png',
                    ],
                },
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap24.png',
                        this.staticState + 'static/images/NewHome/Recap25.png',
                        this.staticState + 'static/images/NewHome/Recap26.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap27.png',
                        this.staticState + 'static/images/NewHome/Recap28.png',
                        this.staticState + 'static/images/NewHome/Recap29.png',
                        this.staticState + 'static/images/NewHome/Recap30.png',
                    ],
                },
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap31.png',
                        this.staticState + 'static/images/NewHome/Recap32.png',
                        this.staticState + 'static/images/NewHome/Recap33.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap34.png',
                        this.staticState + 'static/images/NewHome/Recap35.png',
                        this.staticState + 'static/images/NewHome/Recap36.png',
                        this.staticState + 'static/images/NewHome/Recap37.png',
                    ],
                },
                {
                    group1: [
                        this.staticState + 'static/images/NewHome/Recap38.png',
                        this.staticState + 'static/images/NewHome/Recap39.png',
                        this.staticState + 'static/images/NewHome/Recap40.png',
                    ],
                    group2: [
                        this.staticState + 'static/images/NewHome/Recap41.png',
                        this.staticState + 'static/images/NewHome/Recap42.png',
                        this.staticState + 'static/images/NewHome/Recap43.png',
                        this.staticState + 'static/images/NewHome/Recap44.png',
                    ],
                }
            )
            console.log(this.language, '看看this.language----')
            if (this.language === 'en') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05en.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20en.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400en.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426en.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5en.png'
            } else if (this.language === 'fa') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05fa.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20fa.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400fa.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426fa.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5fa.png'
            } else if (this.language === 'ko') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05ko.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20ko.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400ko.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426ko.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5ko.png'
            } else if (this.language === 'zh-TC') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05zh-TC.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20zh-TC.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400zh-TC.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426zh-TC.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5zh-TC.png'
            } else if (this.language === 'ja') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05ja.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20ja.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400ja.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426ja.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5ja.png'
            } else if (this.language === 'ru') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05ru.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20ru.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400ru.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426ru.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5ru.png'
            } else if (this.language === 'uk') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05uk.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20uk.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400uk.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426uk.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5uk.png'
            } else if (this.language === 'vi') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05vi.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20vi.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400vi.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426vi.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5vi.png'
            } else if (this.language === 'es') {
                this.storyList[0].group1[2] =
                    this.staticState + 'static/images/NewHome/10.05es.png'
                this.storyList[0].group2[1] =
                    this.staticState + 'static/images/NewHome/20es.png'
                this.storyList[1].group1[1] =
                    this.staticState + 'static/images/NewHome/400es.png'
                this.storyList[1].group1[2] =
                    this.staticState + 'static/images/NewHome/426es.png'
                this.storyList[1].group2[1] =
                    this.staticState + 'static/images/NewHome/6.5es.png'
            }
        },
        createFooterObserver() {
            // let swipe = null;
            return new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (!(entry.target instanceof HTMLVideoElement)) return
                        if (entry.isIntersecting) {
                            const playPromise = entry.target.play()
                            if (playPromise && playPromise instanceof Promise) {
                                playPromise
                                    .then(() => {
                                        console.log('视频播放成功')
                                    })
                                    .catch(() => {
                                        console.log('视频播放失败')
                                    })
                            }
                        } else {
                            entry.target.pause()
                            entry.target.currentTime = 0
                        }
                    })
                },
                { threshold: [0] }
            )
        },
    },

    // function changeVideoRate() {
    //     if (!video.value) return;
    //     const currentTime = video.value.currentTime;
    //     const percent = currentTime / video.value.duration;
    //     // const playbackRate = 1 - percent / 3;
    //     gsap.set(video.value, {
    //         opacity: 1 - percent,
    //     });

    //     // video.value.playbackRate = playbackRate;
    // }

    // let observer: IntersectionObserver | null = null;

    mounted() {
        this.initializeStoryList()
        const swiperDom = this.$refs.swiperDom
        const prevBtn = this.$refs.prevBtn
        const nextBtn = this.$refs.nextBtn
        const video = this.$refs.video
        if (!swiperDom) return
        this.swiper = new Swiper(swiperDom, {
            loop: false,
            speed: 750,
            freeMode: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
            breakpoints: {
                1400: {
                    spaceBetween: 16,
                },
            },
        })
        this.observer = this.createFooterObserver()
        this.observer.observe(video)
    },

    // onMounted(() => {

    // });
    beforeDestroy() {
        this.swiper && this.swiper.destroy()
        this.observer && this, observer.disconnect()
    },
}
</script>
<style lang="scss" module>
@import '../../../assets/uemo-scss/scss/abstracts/_mixins.scss';
@import '../../../assets/uemo-scss/scss/abstracts/_functions.scss';
/* @import "../../../assets/uemo-scss/scss/entry.scss"; */
.m-story {
    --g--container-width: 100%;
    --g--container-space: 0;
    position: relative;

    overflow: hidden;

    padding: 86px 0 196px;
    .m-bg {
        position: absolute;
        top: 10px;
        left: 0;
        left: 50%;

        display: flex;

        width: 800px;

        transform: translateX(-50%);
        pointer-events: none;

        justify-content: center;
        mix-blend-mode: lighten;
        video {
            transform-origin: top center;
        }
        &::after {
            @include ab-cover;
            z-index: var(--g--z-index);

            content: '';

            background: linear-gradient(
                180deg,
                color(var(--g--color-bg--default)) 0%,
                color(var(--g--color-bg--default), 0) 30%,
                color(var(--g--color-bg--default), 0) 100%,
                color(var(--g--color-bg--default)) 100%
            );
        }
    }
    .m-container {
        position: relative;
        z-index: calc(var(--g--z-index) * 2);
    }
}
.module-info {
    width: 640px;
    margin-bottom: 180px;

    text-align: center;
    .module-title {
        font-size: 52px;
        font-weight: 700;
        line-height: 120%;
        color: #fff;
        letter-spacing: -1.04px;
        span {
            display: block;
            height: 3rem;
        }
    }
    .module-subtitle {
        font-size: 20px;
        line-height: 160%;

        width: 520px;
        margin: 0 auto;
        margin-top: 20px;

        text-align: center;

        color: color(var(--g--color-font--default), 0.6);
    }
}
.module-body {
    position: relative;
    .swiper {
        padding: 0 40px;
    }
    .swiper-nav {
        font-size: 24px;

        position: absolute;
        top: calc(100% + 60px);
        left: 0;

        width: 100%;
        .btn--swiper-prev,
        .btn--swiper-next {
            @include circle(52px);
            transition: 0.26s ease;
            color: #fff;
            border: 3px solid rgba(#dfe9fb, 0.3);
            &:hover {
                // border-color: color(var(--g--color-theme--main));
                border-color: #FFC72B;
            }
        }
    }
}
.list-item {
    --w: 508px;
    --gap: 16px;
    display: grid;

    width: fit-content;

    gap: 0 var(--gap);
    .item-group1,
    .item-group2 {
        gap: var(--gap);
        .image-box {
            overflow: hidden;

            border-radius: 14px;
        }
    }
    .item-group1 {
        grid-template-columns: var(--w) repeat(1, calc(var(--w) * 0.3));
        grid-template-rows: repeat(2, 1fr);
        .image-box {
            &:nth-of-type(1) {
                @include image-placeholder-v4(580, 580);
                grid-area: 1 / 1 / 3 / 2;
            }
            &:nth-of-type(2) {
                @include image-placeholder-v4(174, 282);
                grid-area: 1 / 2 / 2 / 3;
            }
            &:nth-of-type(3) {
                @include image-placeholder-v4(174, 282);
                grid-area: 2 / 2 / 3 / 3;
            }
        }
    }
    .item-group2 {
        grid-template-columns: var(--w) repeat(2, calc(var(--w) * 0.3));
        grid-template-rows: repeat(2, 1fr);
        .image-box {
            &:nth-of-type(1) {
                @include image-placeholder-v4(580, 579);
                grid-area: 1 / 1 / 3 / 2;
            }
            &:nth-of-type(2) {
                @include image-placeholder-v4(174, 282);
                grid-area: 1 / 2 / 2 / 3;
            }
            &:nth-of-type(3) {
                @include image-placeholder-v4(174, 282);
                grid-area: 1 / 3 / 2 / 4;
            }
            &:nth-of-type(4) {
                @include image-placeholder-v4(364, 246);
                grid-area: 2 / 2 / 3 / 4;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/compontents/newHome/index/StoryModule.vue